import { createFileRoute } from "@tanstack/react-router";
import { Brain, UserPlus, Wand2 } from "lucide-react";
import { PlatformHub } from "@/components/marketing/PlatformHub";
import { alternateLinkList } from "@/lib/i18n/locale";
import aiImg from "/lovable-uploads/11749302-d433-4877-9acb-ac3108b72948.webp";

export const Route = createFileRoute("/el/platform/ai-suite")({
  head: () => ({
    meta: [
      { title: "Σουίτα AI — banana.cards" },
      { name: "description", content: "AI Brain για κάθε επαφή, αυτόματος εμπλουτισμός και εργαλεία AI για σύνταξη, μετάφραση και αξιολόγηση — όπου κι αν εργάζεστε." },
      { property: "og:title", content: "Σουίτα AI — banana.cards" },
      { property: "og:description", content: "AI Brain για κάθε επαφή, αυτόματος εμπλουτισμός και εργαλεία AI για σύνταξη, μετάφραση και αξιολόγηση — όπου κι αν εργάζεστε." },
      { property: "og:image", content: aiImg },
      { property: "og:locale", content: "el_GR" },
    ],
    links: alternateLinkList("/platform/ai-suite", "el"),
  }),
  component: Page,
});

function Page() {
  return (
    <PlatformHub
      eyebrow="AI"
      title="Ένας προσωπικός επιτελάρχης,"
      italic="για κάθε επαφή."
      description="AI που θυμάται κάθε συζήτηση, εμπλουτίζει κάθε επαφή και γράφει κάθε follow-up — ενσωματωμένο στο Banana, όχι απλώς πρόσθετο."
      heroImage={aiImg}
      features={[
        { title: "AI Brain", desc: "Ο δεύτερος εγκέφαλός σας για κάθε συζήτηση. Ρωτήστε σε απλά αγγλικά και λάβετε απαντήσεις, προσχέδια και επόμενα βήματα.", href: "/el/platform/ai", icon: Brain, bullets: ["Ερωτήματα CRM σε απλά αγγλικά", "Φωνητικές σημειώσεις και περιλήψεις", "Σύνταξη follow-up με AI"] },
        { title: "Εμπλουτισμός με AI", desc: "Αυτόματη συμπλήρωση θέσης, εταιρείας, κοινωνικών προφίλ και ενδείξεων για κάθε επαφή — από ένα email, μια σάρωση ή ένα URL LinkedIn.", href: "/el/platform/ai-enrichment", icon: UserPlus, bullets: ["85% αυτόματη συμπλήρωση πεδίων", "60+ πηγές δεδομένων", "Προγραμματισμένη ανανέωση"] },
        { title: "Εργαλεία AI", desc: "Σύνταξη, μετάφραση, περιλήψεις, βαθμολόγηση υποψήφιων πελατών και προτάσεις επόμενων βημάτων — εκεί που εργάζεστε.", href: "/el/platform/ai-tools", icon: Wand2, bullets: ["12+ εργαλεία AI", "50+ γλώσσες", "Επιλογή μοντέλου ανά λειτουργία"] },
      ]}
      outro={{ title: "Αφήστε τις δουλειές ρουτίνας στο AI.", italic: "Εσείς χτίστε σχέσεις.", description: "AI στη συλλογή επαφών, το CRM και το follow-up — με τη συγκατάθεσή σας, με διαφάνεια και υπό τον έλεγχό σας." }}
    />
  );
}
